export function filterReg (para,type) {
    let reg = ''
    let state
    switch (type) {
      case 'email':
        reg = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]{2,})+$/i
        state = reg.test(para)
        break;
      case 'pwd':
          reg = /^(\w){6,20}$/
          state = reg.test(para)
          break;
      case 'url':
            reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?/
            state = reg.test(para)
            break;
      case 'command':
            reg = /^([1-9]\d*|0)(\.\d*[1-9])?$/
            state = reg.test(para)
            break;
    }
    return state
}